import Interceptor from "@/plugins/interceptor.js";

const urlAPI = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_SURVEY}`;

const Survey = {
  state: {
    templates: []
  },
  actions: {
    getTemplates: async ({ commit }) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getTemplates`);
        commit("SET_templates", response.data);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    createTemplate: async (_, model) => {
      try {
        const response = await Interceptor.post(
          `${urlAPI}/createTemplate`,
          model
        );
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    updateTemplate: async (_, model) => {
      try {
        const response = await Interceptor.put(
          `${urlAPI}/updateTemplate`,
          model
        );
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    createSurvey: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/create`, model);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    deleteTemplate: async (_, model) => {
      try {
        const response = await Interceptor.delete(`${urlAPI}/deleteTemplate?templateId=${model.templateId}`)
        return response 
      } catch (error) {
        console.error(error)
      }
    },
    getFinished: async (_, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getFinished?gameId=${params.gameId}&teamId=${params.teamId}`)
        return response
      } catch (error) {
        console.error(error)
      }
    }
  },
  mutations: {
    SET_templates(state, value) {
      state.templates = value;
    }
  }
};

export default Survey;
